import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";

class CheckControlPinTask extends AbstractRequestTask {
  constructor(params, version = 'v1') {
    super();
    this.version = version;
    this.ownParams = params;
  }

  getParams() {
    const params = super.getParams();
    const user = store.getState().user;
    const user_id = user.user_id || "";
    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params, { user_id, ...this.ownParams });

  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'checkcontrolpin';

    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

}

export default CheckControlPinTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/CheckControlPinTask.js